import React from 'react'
import Layout from '../Layout';

export default function Logistics() {
  return (
    <Layout>
    <div className='content1'>Logistics</div>
    </Layout>
  )
}
